export const UserTypePermissions = [
  { value: "admin_panel", label: "Admin Panel" },
  { value: "manage_user_type", label: "Manage User Type" },
  { value: "manage_user", label: "Manage User" },
  { value: "manage_store", label: "Manage Locations" },
  { value: "manage_plastic_seal", label: "Manage Plastic Seal" },
  { value: "create_booking_order", label: "Create Booking Order" },
  { value: "new_booking_orders", label: "New Booking Orders" },
  { value: "manage_booking_orders", label: "Manage Booking Orders" },
  { value: "manage_route_point", label: "Manage Route Point" },
  { value: "manage_route", label: "Manage Route" },
  { value: "manage_trip", label: "Manage Trip" },
  { value: "manage_country", label: "Manage Country" },
  { value: "report_issue", label: "Report Issue" },
  { value: "check_delivery_status", label: "Check Delivery Status" },
  { value: "tranfer_package", label: "Transfer Package" },
  { value: "settings", label: "Settings" },
];
